import {
  SET_CONFIG, SET_CONFIG_ENVIRONMENT,
} from './actionTypes';

export const setConfig = (settings) => (dispatch) => {
  dispatch({
    type: SET_CONFIG,
    payload: settings,
  });
};

export const setConfigEnvironment = (environment) => (dispatch) => {
  dispatch({
    type: SET_CONFIG_ENVIRONMENT,
    payload: environment,
  });
};
